import { ADDITIONAL_PRODUCT, COMMON } from '@constants';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';

export const usePimsterUITranslations = () => {
    const { t } = useTranslation([ADDITIONAL_PRODUCT, COMMON]);

    return useMemo(
        () => ({
            'cart.add': t('actions.add_to_cart.label'),
            'cart.addSuccess': t('actions.add_to_cart.success'),
            'cart.view': t('actions.add_to_cart.see_cart'),
            see: t('actions.see'),
            error: t('actions.add_to_cart.error'),
            model: t('variant.model_select_label'),
            select: t('select', { ns: COMMON }),
            showLess: t('show_less', { ns: COMMON }),
            showMore: t('show_more', { ns: COMMON }),
        }),
        [t]
    );
};
